module.exports = __webpack_public_path__ + "img/empty-cart.94c871fa.svg";